import { setIsFileDownloading } from '@src/store/fileDownloadSlice.ts';
import { AppDispatch } from '@src/store/store.ts';
import logger from '@src/utils/logger';
import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

const useFileDownload = () => {
  const dispatch = useDispatch<AppDispatch>();

  const getDownloadUrl = useCallback(
    async (fileUrl: string): Promise<{ url: string; shouldRevoke: boolean }> => {
      if (fileUrl.startsWith('blob:')) {
        return { url: fileUrl, shouldRevoke: false };
      }

      const response = await axios.get(fileUrl, {
        responseType: 'blob',
        withCredentials: false,
        headers: {},
      });

      const blobData = response.data;
      const downloadUrl = URL.createObjectURL(blobData);

      return { url: downloadUrl, shouldRevoke: true };
    },
    [],
  );

  const downloadFile = useCallback(
    async (fileUrl?: string, fileName?: string) => {
      const isIOS: boolean = /iPad|iPhone|iPod/.test(navigator.userAgent);

      try {
        if (!fileUrl || !fileName) {
          return;
        }
        dispatch(setIsFileDownloading(true));

        const { url: downloadUrl, shouldRevoke } = await getDownloadUrl(fileUrl);

        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // 作成したURLの取り消し(既にblob URLの場合は不要)
        if (shouldRevoke) {
          URL.revokeObjectURL(downloadUrl);
        }

        window.addEventListener(
          'focus',
          () => {
            if (isIOS) {
              dispatch(setIsFileDownloading(false));
            }
          },
          { once: true },
        );
      } catch (error) {
        logger.error('ファイルのダウンロードに失敗しました:', error);
        throw error;
      } finally {
        if (!isIOS) {
          dispatch(setIsFileDownloading(false));
        }
      }
    },
    [getDownloadUrl, dispatch],
  );

  return { downloadFile };
};

export default useFileDownload;
